/**
 * 3D Hero Carousel Module
 * Extracted from inline <script> in index.html.
 * Handles: product carousel with 3D rotateY transforms, elastic easing,
 * auto-rotation, touch swipe, dot navigation, keyboard arrows.
 */

const ALL_CAROUSEL_PRODUCTS = [
  { name: "ZT411", cat: "Impressora", modalCat: "thermal", img: "./assets/img/products/ZT411/ZT411.png" },
  { name: "ZD421", cat: "Impressora", modalCat: "thermal", img: "./assets/img/products/ZD421/ZD421.png" },
  { name: "ZT610", cat: "Impressora", modalCat: "thermal", img: "./assets/img/products/ZT610/ZT610.png" },
  { name: "ZT231", cat: "Impressora", modalCat: "thermal", img: "./assets/img/products/ZT231/ZT231.png" },
  { name: "ZD621", cat: "Impressora", modalCat: "thermal", img: "./assets/img/products/ZD621/ZD621.png" },
  { name: "ZQ630", cat: "Impressora Móvel", modalCat: "thermal", img: "./assets/img/products/ZQ630/ZQ630.png" },
  { name: "TC22", cat: "Coletor", modalCat: "mobile", img: "./assets/img/products/TC22/TC22.png" },
  { name: "TC58", cat: "Coletor", modalCat: "mobile", img: "./assets/img/products/TC58/TC58.png" },
  { name: "MC3300", cat: "Coletor", modalCat: "mobile", img: "./assets/img/products/MC3300/MC33.png" },
  { name: "MC9300", cat: "Coletor", modalCat: "mobile", img: "./assets/img/products/MC9300/MC9300.png" },
  { name: "MC34", cat: "Coletor", modalCat: "mobile", img: "./assets/img/products/MC34/MC34.png" },
  { name: "DS2208", cat: "Scanner", modalCat: "scanners", img: "./assets/img/products/DS2208/DS2208.png" },
  { name: "DS8178", cat: "Scanner", modalCat: "scanners", img: "./assets/img/products/DS8178/DS8178.png" },
  { name: "DS9308", cat: "Scanner", modalCat: "scanners", img: "./assets/img/products/DS9308/DS9308.png" },
  { name: "DS3608", cat: "Scanner", modalCat: "scanners", img: "./assets/img/products/DS3608/DS3608.png" },
  { name: "ET40", cat: "Tablet", modalCat: "tablets", img: "./assets/img/products/ET40/ET40.png" },
  { name: "ET45", cat: "Tablet", modalCat: "tablets", img: "./assets/img/products/ET40/ET40.png" },
  { name: "L10", cat: "Tablet", modalCat: "tablets", img: "./assets/img/products/L10/L10.png" },
  { name: "WT6300", cat: "Wearable", modalCat: "wearables", img: "./assets/img/products/WT6300/WT6300.png" },
  { name: "RS6100", cat: "Wearable", modalCat: "wearables", img: "./assets/img/products/RS6100/RS6100.png" },
  { name: "WS50", cat: "Wearable", modalCat: "wearables", img: "./assets/img/products/WS50/WS50.png" },
  { name: "AP4000", cat: "Networking", modalCat: "extreme", img: "./assets/img/products/AP4000/AP4000-carousel.png" },
  { name: "AP5010", cat: "Networking", modalCat: "extreme", img: "./assets/img/products/AP5010/AP5010.png" },
  { name: "AP305C", cat: "Networking", modalCat: "extreme", img: "./assets/img/products/AP305C/AP305C.png" },
];

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/** Elastic easing function for swing effect */
function elasticOut(t) {
  const p = 0.4;
  return Math.pow(2, -10 * t) * Math.sin(((t - p / 4) * (2 * Math.PI)) / p) + 1;
}

export function initCarousel() {
  const scene = document.getElementById("carouselScene");
  const dotsContainer = document.getElementById("carouselDots");
  const prevBtn = document.getElementById("carouselPrev");
  const nextBtn = document.getElementById("carouselNext");

  if (!scene) return;

  const isMobile = window.innerWidth <= 768;
  // Raio da "órbita" virtual usado para projetar os cards em 2D.
  // Define a separação horizontal máxima entre cards laterais e o central.
  const radius = isMobile ? 880 : 1150;
  const products = shuffle(ALL_CAROUSEL_PRODUCTS);
  const count = products.length;
  const angleStep = 360 / count;

  let currentAngle = 0;
  let currentIndex = 0;
  let autoRotateTimer = null;
  let isTransitioning = false;

  // Build cards
  const cardEls = [];
  const cardAngles = [];

  products.forEach((product, i) => {
    const angle = angleStep * i;
    const card = document.createElement("div");
    card.className = "carousel-card";
    // Inicialmente todos os cards ficam fora da viewport — updateCardVisibility
    // posiciona apenas os que estão visíveis em cada frame.
    card.style.transform = `translate(-9999px, 0)`;
    cardEls.push(card);
    cardAngles.push(angle);
    card.innerHTML =
      `<span class="product-category">${product.cat}</span>` +
      `<img src="${product.img}" alt="${product.name}" loading="eager">` +
      `<span class="product-name">${product.name}</span>`;

    // Click on card opens the product modal page, scrolled to this product
    card.addEventListener("click", () => {
      if (typeof window.openProductModal === "function") {
        window.openProductModal(product.modalCat, product.name);
      }
    });

    scene.appendChild(card);
  });

  // Build dots
  if (dotsContainer) {
    products.forEach((_, i) => {
      const dot = document.createElement("button");
      dot.className = "carousel-dot" + (i === 0 ? " active" : "");
      dot.setAttribute("aria-label", "Produto " + (i + 1));
      dot.addEventListener("click", () => goToIndex(i));
      dotsContainer.appendChild(dot);
    });
  }

  function updateDots() {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll(".carousel-dot");
    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === currentIndex);
    });
  }

  // Posiciona apenas os 3 cards visualmente próximos do centro.
  // Renderização em 2D puro (sem perspective/translateZ) para preservar nitidez.
  function updateCardVisibility(sceneAngle) {
    for (let i = 0; i < cardEls.length; i++) {
      // Ângulo "signed" (-180 a 180) para distinguir lado esquerdo/direito.
      const signed = ((cardAngles[i] + sceneAngle + 180) % 360 + 360) % 360 - 180;
      const eff = Math.abs(signed);
      if (eff > 25) {
        cardEls[i].style.display = "none";
      } else {
        cardEls[i].style.display = "";
        // Center card: full opacity + full scale
        // Side cards: fade out + shrink for depth (scale 2D → imagem nítida)
        const op = eff > 8 ? Math.max(0, 1 - (eff - 8) / 17) : 1;
        const sc = eff > 5 ? Math.max(0.7, 1 - (eff / 80)) : 1;
        // translateX baseado em sin(angle) projeta o card como se estivesse numa
        // órbita circular vista de frente. Sem perspective real, o downscale da
        // <img> é puramente 2D → renderização crisp como na galeria do modal.
        const tx = Math.sin(signed * Math.PI / 180) * radius;
        cardEls[i].style.opacity = op;
        cardEls[i].style.transform =
          `translate(-50%, -50%) translateX(${tx}px) scale(${sc})`;
        // z-index: cards mais centrais ficam por cima
        cardEls[i].style.zIndex = String(100 - Math.round(eff));
      }
    }
  }
  updateCardVisibility(0);

  // Animate with swing/elastic effect
  function animateSwing(startAngle, endAngle, duration, callback) {
    let startTime = null;

    function animate(currentTime) {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = elasticOut(progress);
      const angle = startAngle + (endAngle - startAngle) * easedProgress;

      // Modo 2D: cada card é reposicionado em updateCardVisibility com base no
      // ângulo da cena. Não aplicamos transform no scene em si.
      updateCardVisibility(angle);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else if (callback) {
        callback();
      }
    }
    requestAnimationFrame(animate);
  }

  function rotateTo(angle) {
    if (isTransitioning) return;
    isTransitioning = true;

    const startAngle = currentAngle;
    currentAngle = angle;
    updateDots();

    animateSwing(startAngle, angle, 900, () => {
      isTransitioning = false;
    });
  }

  function rotateLeft() {
    currentIndex = (currentIndex + 1) % count;
    rotateTo(currentAngle - angleStep);
    resetAutoRotate();
  }

  function rotateRight() {
    currentIndex = (currentIndex - 1 + count) % count;
    rotateTo(currentAngle + angleStep);
    resetAutoRotate();
  }

  function goToIndex(idx) {
    const diff = idx - currentIndex;
    currentIndex = idx;
    rotateTo(currentAngle - diff * angleStep);
    resetAutoRotate();
  }

  // Auto-rotate
  function startAutoRotate() {
    autoRotateTimer = setInterval(rotateLeft, 8000);
  }

  function resetAutoRotate() {
    clearInterval(autoRotateTimer);
    startAutoRotate();
  }

  // Navigation buttons
  if (prevBtn) prevBtn.addEventListener("click", rotateRight);
  if (nextBtn) nextBtn.addEventListener("click", rotateLeft);

  // Keyboard navigation (only when carousel is visible)
  document.addEventListener("keydown", (e) => {
    const container = document.getElementById("carouselContainer");
    if (!container) return;
    const rect = container.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;
    if (e.key === "ArrowLeft") rotateRight();
    if (e.key === "ArrowRight") rotateLeft();
  });

  // Touch swipe
  let touchStartX = 0;
  const carouselEl = document.getElementById("carouselContainer");

  if (carouselEl) {
    carouselEl.addEventListener(
      "touchstart",
      (e) => { touchStartX = e.changedTouches[0].screenX; },
      { passive: true },
    );

    carouselEl.addEventListener(
      "touchend",
      (e) => {
        const diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) rotateLeft();
          else rotateRight();
        }
      },
      { passive: true },
    );

    // Pause on hover
    carouselEl.addEventListener("mouseenter", () => clearInterval(autoRotateTimer));
    carouselEl.addEventListener("mouseleave", () => startAutoRotate());
  }

  // Start auto-rotation
  startAutoRotate();
}
